import {Component, OnInit, HostListener} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';
import {WorkOrderSummary} from '../../models/work-order-summary';
import {UtilitiesService} from '../../services/utilities.service';
import {MatSnackBar} from '@angular/material';
import {InspectionUploadArgs} from '../../models/inspection-upload';
import {
  ToastSuccessComponent
} from '../../parts/toast-success/toast-success.component';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})
export class OrderComponent implements OnInit {
  policyId: string;
  policySummary: any;
  workOrders: WorkOrderSummary[] = [];
  loadingMoreHistory = false;
  loadingHistory = false;
  hasMoreHistory = false;
  mobileIndex = 0;
  canRenew = false;
  private swipeCoord?:[number, number];
  private swipeTime?: number;
  loadingPolicy = false;
  loadingInspection = false;
  emailToSendTo = '';
  showResendConfirmation = false;
  resendingQuote = false;

  constructor(private route: ActivatedRoute,
              private realtorPortalService: RealtorPortalService,
              private snakbar: MatSnackBar) {}

  get baseUrl() { return UtilitiesService.baseAPIUrl; }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.policyId = params['id'];



      this.loadingPolicy = true;
      this.realtorPortalService.getPolicySummaryById(this.policyId)
          .then(ps => {

            if (ps && ps.PolicySummary &&
                ps.PolicySummary.EstimatedClosingDate) {
              ps.PolicySummary.EstimatedClosingDate =
                  new Date(ps.PolicySummary.EstimatedClosingDate);
            }

            this.policySummary = ps;

            this.loadingPolicy = false;

            let daysTillExpiration = 0;
            if (this.policySummary.PolicySummary.ExpirationDate) {
              const oneDay = 24 * 60 * 60 * 1000;
              daysTillExpiration = Math.round(Math.abs(
                  (new Date().getTime() -
                   new Date(this.policySummary.PolicySummary.ExpirationDate)
                       .getTime()) /
                  (oneDay)));
            }

            setTimeout(() => this.canRenew =
                           this.policySummary.PolicySummary.CanRenew &&
                           daysTillExpiration < 45,
                       1000);

            this.realtorPortalService.getClaimHistoryByPolicyId(this.policyId,
                                                                null, 10)
                .then(items => {
                  this.hasMoreHistory = items.length === 10;
                  this.workOrders = items;
                });
          });

      this.realtorPortalService.getSideBarInfo().then(
          sideBar => { this.emailToSendTo = sideBar.Email; });
    });
  }

  @HostListener('window:hashchange', ['$event'])
  watchUrlHash(event) {
    const hash = window.location.hash;

    if (hash === '#Home') {
      this.mobileIndex = 0;
    } else if (hash === '#Documents') {
      this.mobileIndex = 1;
    } else {
      this.mobileIndex = 0;
    }
  }

  estimatedClosingDateChanged(e) {
    const date: Date = e;
    if (date.getFullYear() >= new Date().getFullYear()) {
      this.realtorPortalService.updateEstimatedClosingDate(this.policyId, e);
    }
  }

  get canResendOrderConfirmation() {
    return this.emailToSendTo &&
           UtilitiesService.isEmailValid(this.emailToSendTo);
  }

  onStepChange() {
    if (this.mobileIndex === 0) {
      window.location.hash = 'Home';
    } else if (this.mobileIndex === 1) {
      window.location.hash = 'Documents';
    }
  }

  loadMoreHistory() {
    this.loadingMoreHistory = true;
    const lastItemDate = this.workOrders[this.workOrders.length - 1].Date;

    lastItemDate.setSeconds(lastItemDate.getSeconds());

    this.realtorPortalService.getClaimHistoryByPolicyId(this.policyId,
                                                        lastItemDate, 10)
        .then(moreHistory => {
          moreHistory.forEach(item => {
            this.workOrders.push(item);
            this.loadingMoreHistory = false;
            this.hasMoreHistory = moreHistory.length === 10;
          });
        });
  }

  resendQuote() {
    this.resendingQuote = true;
    this.realtorPortalService.resendOrderConfirmation(this.policyId,
                                                      this.emailToSendTo)
        .then(() => {

          this.resendingQuote = false;
          this.showResendConfirmation = false;
          this.snakbar.openFromComponent(ToastSuccessComponent, {
            data: 'The order confirmation has been sent.',
            duration: 10000,
            panelClass: ['success-toast']
          });
        });
  }

  showFileUpload() { document.getElementById('fileToUpload1').click(); }

  handleFileUpload(evt) { this.handleFiles(evt); }

  handleFiles(files) {
    if (files.srcElement) {
      files = files.srcElement.files;
    }
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();

      const loadIt = (base64, fileName) => {
        this.loadingInspection = true;
        const inspectionUploadArgs = new InspectionUploadArgs();
        inspectionUploadArgs.PolicyId = this.policyId;
        inspectionUploadArgs.FileName = fileName;
        inspectionUploadArgs.Attachment = base64;


        this.realtorPortalService.uploadInspection(inspectionUploadArgs)
            .then(result => {
              this.loadingInspection = false;
              this.snakbar.openFromComponent(ToastSuccessComponent, {
                data: 'Your inspection has been uploaded. Thank You.',
                duration: 10000,
                panelClass: ['success-toast']
              });
            });
      };

      reader.onload = (function(fileName) {
        return function(e) {
          this.dragTargetActive = false;
          loadIt(e.target.result, fileName);

        };
      })(file.name);

      reader.readAsDataURL(file);
    }
  }

  swipe(e: TouchEvent, when: string): void {
    if (this.policySummary &&
        this.policySummary.PolicySummary.PolicyNumber === -1) {
      return;
    }

    const coord:[number, number] =
        [e.changedTouches[0].pageX, e.changedTouches[0].pageY];
    const time = new Date().getTime();

    if (when === 'start') {
      this.swipeCoord = coord;
      this.swipeTime = time;
    } else if (when === 'end') {
      const direction =
          [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
      const duration = time - this.swipeTime;

      if (duration < 1000 && Math.abs(direction[0]) > 60 &&
          Math.abs(direction[0]) > Math.abs(direction[1] * 3)) {
        const swipe = direction[0] < 0 ? 'next' : 'previous';
        if (swipe === 'next') {
          if (this.mobileIndex < 3) {
            this.mobileIndex++;
            window.scrollTo({
              left: 0,
              top: 0,
              behavior: 'smooth',
            });
          }
        } else {
          if (this.mobileIndex !== 0) {
            this.mobileIndex--;
            window.scrollTo({
              left: 0,
              top: 0,
              behavior: 'smooth',
            });
          }
        }
      }
    }
  }
}
